import { render, staticRenderFns } from "./update-config.vue?vue&type=template&id=aaf2edac"
import script from "./update-config.vue?vue&type=script&lang=js"
export * from "./update-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports